// this class matches the backend model with attribute validation transferred to frontend via validationRulesService.
// Then this part is initialized as groupDetailsValidationModel.js which allows applying ko.validation rules in traditional way
export class GroupDetailsDto {
  constructor(public readonly groupName: string,
    public readonly address: string,
    public readonly isLocationAssigned: boolean,
    public readonly coordinate: Array<number>) { }
}
